"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _BuySellInstrumentSelector = _interopRequireDefault(require("./BuySellInstrumentSelector"));
var _instrumentPositionSelectors = require("../../../../../redux/selectors/instrumentPositionSelectors");
var _buySellActions = require("../../../../../redux/actions/buySellActions");
var _buySellSelectors = require("../../../../../redux/selectors/buySellSelectors");
var _selectors = require("../../../../../redux/margin/selectors");
var _config = _interopRequireDefault(require("../../../../../config"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  var dealPrices = _config["default"].RetailBuySell.dealPrices;
  var isBuySide = (0, _buySellSelectors.isBuySideBuySellFormSelector)(state);
  // t('Choose a Crypto to Buy');
  // t('Choose a Crypto to Sell');
  var label = isBuySide ? 'Choose a Crypto to Buy' : 'Choose a Crypto to Sell';
  var instruments = (0, _instrumentPositionSelectors.instrumentsWithProductFullNamesAndProductSymbols)(state);
  var isMarginActive = (0, _selectors.isMarginActiveSelector)(state);
  if (!isMarginActive) {
    var filteredInstruments = instruments.filter(function (instrument) {
      return Object.prototype.hasOwnProperty.call(dealPrices, instrument.Symbol);
    });
    if (filteredInstruments.length) instruments = filteredInstruments;
  }
  return {
    instruments: instruments,
    selectedInstrument: (0, _instrumentPositionSelectors.selectedInstrumentSelector)(state),
    label: label
  };
};
var mapDispatchToProps = {
  onInstrumentSelect: _buySellActions.onInstrumentSelect
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_BuySellInstrumentSelector["default"]);